import React from "react";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Card,
  CardContent,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CardHeader from "./CardHeader.jsx";
import { faUsers } from "@fortawesome/pro-solid-svg-icons";
import * as f from "../../../utils/formatter.js";

/**
 * @typedef {Object} LegalGuardian
 * @property {string} name
 * @property {string} relationship
 */

/**
 * @typedef {Object} LegalGuardianCardProps
 * @property {LegalGuardian[]} legalGuardians
 */

/**
 * @param {LegalGuardianCardProps} props
 */
const LegalGuardianCard = ({ legalGuardians }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <CardHeader
          title={t("legalGuardians.card.title")}
          color={theme.palette.info.main}
          faIcon={faUsers}
        />
        {legalGuardians.length > 0 ? (
          <List>
            {legalGuardians.map((guardian) => (
              <ListItem key={guardian.id}>
                <ListItemText
                  primary={f.fullName(guardian)}
                  secondary={
                    <>
                      <strong>{t("legalGuardians.card.phone")}:</strong>{" "}
                      {guardian.phone || t("legalGuardians.card.noPhone")}
                      <br />
                      <strong>{t("legalGuardians.card.email")}:</strong>{" "}
                      {guardian.email || t("legalGuardians.card.noEmail")}
                      <br />
                      <strong>
                        {t("legalGuardians.card.birth_number")}:
                      </strong>{" "}
                      {guardian.birth_number}
                    </>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography variant="body1">
            {t("legalGuardians.noGuardians")}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default LegalGuardianCard;
